import { AgentApiPath, useHallApi } from '@99fun-agent/hooks'
import { defineStore } from 'pinia'

export const useRecordStore = defineStore('recordStore', () => {
  const { authGet } = useHallApi()

  const reqGetRecords = async (reqData: IGetRecordReq) => {
    const r = await authGet<IGetRecordReply>(AgentApiPath.GetRecords, reqData, {
      showLoading: true,
      showErrorCodeTip: true
    })

    return r.data
  }

  const reset = () => {}
  return { reset, reqGetRecords }
})

export interface IGetRecordReq {
  startDate: string
  endDate: string
}

export interface IGetRecordReply {
  records: IRecordInfo[]
}

export interface IRecordInfo {
  date: string
  time: string
  registerCount: number
  loginCount: number
  depositAmount: number
  withdrawAmount: number
  validBetAmount: number
  winAmount:number
  netEarning: number
  bonusAmount: number
}
